import { render, staticRenderFns } from "./TypeDialog.vue?vue&type=template&id=d4445e3a&"
import script from "./TypeDialog.vue?vue&type=script&lang=js&"
export * from "./TypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./TypeDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TypeDialog.vue"
export default component.exports